// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"d646f60c5e555e3d","294":"0bdfc3b4c188fe00","488":"953af7bb643d4da4","549":"2a54d7513eb7c708","793":"42ef63b7ec463244","799":"53bff7e556abe3ec","850":"9094ce8c75d867bf"}[chunkId] + ".js";
};